import { useDirectusStore } from "@/modules/directus/store/directus";
import { readItems } from "@directus/sdk";
import { defineStore } from "pinia";
import RightsCategoryInterface from "../interfaces/RightsCategoryInterface";
import i18n from "@/plugins/i18n";
import { ref, watch } from "vue";

export const useRightStore = defineStore("right", () => {
  const directusStore = useDirectusStore();

  const categories = ref<RightsCategoryInterface[]>([]);

  const getRightsCategories = async () => {
    categories.value = (await directusStore.city?.request(
      readItems("rights_categories", {
        fields: ["*"],
        filter: {
          language: { code: { _eq: i18n.global.locale.value } },
        },
      })
    )) as RightsCategoryInterface[];
  };

  watch(
    () => directusStore.city,
    () => {
      categories.value = [];
      getRightsCategories();
    }
  );

  watch(
    () => i18n.global.locale.value,
    () => {
      categories.value = [];
      getRightsCategories();
    }
  );

  return { getRightsCategories, categories };
});
